import { Box, styled } from '@withjoy/joykit';

export const SliderContainer = styled(Box)<{ aspectRatio?: number }>`
  .slick-slider {
    width: 100%;
    height: 100%;
    ${({ aspectRatio }) => aspectRatio && `aspect-ratio: ${aspectRatio};`}
  }
  .slick-dots {
    bottom: 30px;
    pointer-events: auto;
  }
  .slick-dots li {
    width: auto;
    height: auto;
    margin: 0 6px;
  }
  .slick-dots .slick-active .custom-dot {
    background-color: ${({ theme }) => theme.colors.accentBlue2};
  }

  .slick-prev,
  .slick-next {
    display: none !important;
  }
`;
